import React from 'react';

function SceneSelector({ currentScene, scenes, onSceneChange }) {
    if (!scenes || scenes.length === 0) return null;

    return (
        <div className="admin-scene-selector">
            <label htmlFor="scene-select">Scene:</label>
            <select
                id="scene-select"
                value={currentScene}
                onChange={(e) => onSceneChange(Number(e.target.value))}
            >
                {scenes.map((scene) => (
                    <option key={scene.sceneIndex} value={scene.sceneIndex}>
                        {scene.sceneIndex}. {scene.name}
                    </option>
                ))}
            </select>
        </div>
    );
}

export default SceneSelector;
